/**
 * 🔍 Vision Service — Ersetzt Firebase Cloud Functions
 * 
 * Nutzt den zentralen API-Client (mit JWT-Auth) für:
 *   - Paketlabel-Analyse (Gemini Vision)
 *   - Hermes-Beleg OCR (Gemini Vision)
 */

import { api } from './apiService';

/**
 * Analysiert ein Paketlabel-Bild und gibt strukturierte Daten zurück.
 * Ersetzt: fetch('https://europe-west1-myapp-fc38d.cloudfunctions.net/visionAnalyze')
 * 
 * @param {string} base64Image - Base64-Bilddaten (ohne data:... Prefix)
 * @param {string} [prompt] - Optionaler Custom-Prompt
 * @returns {Promise<{text: string, usage: Object, duration: number}>}
 */
export async function analyzePackageLabel(base64Image, prompt) {
  return api.post('/vision/analyze', {
    image: base64Image,
    prompt: prompt || undefined
  });
}

/**
 * Direkter Gemini-Aufruf mit EIGENEM Prompt (befolgt den Prompt wirklich —
 * anders als /vision/analyze, das an den Label-ML-Service weiterleitet).
 * Für die Ausgabe: Abholkarte / Ausweis / Führerschein / Label robust auslesen.
 * @returns {Promise<{text: string, usage: Object, duration: number}>}
 */
export async function analyzeImageWithPrompt(base64Image, prompt) {
  return api.post('/vision/prompt', {
    image: base64Image,
    prompt,
  });
}

/**
 * Führt OCR auf einem Hermes-Beleg durch.
 * Ersetzt: fetch('https://europe-west1-myapp-fc38d.cloudfunctions.net/hermesVisionOCR')
 * 
 * @param {string} base64Image - Base64-Bilddaten (ohne data:... Prefix)
 * @returns {Promise<{text: string, confidence: number, duration: number}>}
 */
export async function hermesVisionOCR(base64Image) {
  return api.post('/vision/hermes-ocr', {
    image: base64Image
  });
}
